import { createClient } from '@supabase/supabase-js';

export const supabaseUrl = "https://ayjoeoeltdgfokqpvovb.supabase.co";
// It's generally better to use environment variables for these, especially the anon key if it's public.
// For local development, this is okay, but consider process.env.VITE_SUPABASE_URL etc. for Vite.
const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF5am9lb2VsdGRnZm9rcXB2b3ZiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDc0MTgwMjUsImV4cCI6MjA2Mjk5NDAyNX0.lnmc3qt71W_ab1D-wIeRKLe9GGUMUVFjtDnlSHkQGcE";

export const supabase = createClient(supabaseUrl, supabaseAnonKey); 